import { createContextualCan } from '@casl/react';
import { AppAbility } from '@readcloud/casl';
import { createContext } from 'react';

export const AbilityContext = createContext<AppAbility>(null);

export const Can = createContextualCan(AbilityContext.Consumer);
